<template>
  <app-transition>
    <Dialog class="InformMessage" :only-text="true" @close="handleClose">
      <div class="mystery-box-confirm-container">
        <div class="box-open-confirmation">
            <v-row text-center class="confirm-message">
                <v-col>
                    <div class="SubscriptionPrice-title">
                    {{ $t('dialogs.mystery_box_confirmation') }}
                    </div>
                </v-col>
            </v-row>
        
            <v-row class="confirm-message-option">
                <v-col>
                    <v-btn outlined block class="text-capitalize" @click="openBox">
                    {{ $t('dialogs.yes') }}
                    </v-btn>
                </v-col>
                <v-col>
                    <v-btn outlined block class="text-capitalize" @click="handleClose">
                    {{ $t('dialogs.no') }}
                    </v-btn>
                </v-col>
            </v-row>
        </div>
      </div>
    </Dialog>
  </app-transition>
</template>

<script>
import Radio from "@/components/app/form/Radio";
import GradientButton from "@/components/app/button/GradientButton";
import VerifyDialog from "@/components/app/dialogs/VerifyDialog";
import InformDialog from "@/components/app/dialogs/InformDialog";
import { mapState } from "vuex";
import Dialog from "@/components/app/form/Dialog";

export default {
  name: "MysteryBoxConfirmationDialog",
  data: () => ({
  }),
  props: {
    price: { 
        type: Number,
        required: true,
    },
  },
  computed: {
    ...mapState({
      verified: (state) => state.user.user.data.verified,
      currentUser: (state) => state.user.user.data,
    }),    
  },
  methods: {
    handleClose() {
        this.$emit("close");
    },
    openBox() {
        this.$emit("open-box");
    },
  },
  components: {
    GradientButton,
    Radio,
    VerifyDialog,
    InformDialog,
    Dialog,
  },
};
</script>

<style scoped lang="scss">
@import "@/sass/modules/_variables";

</style>
